import styled from 'styled-components';

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    background: ${(props) => props.theme.colors.primaryWhite};
    height: 40px;
    width: 272px;
`;

const InputField = styled.input`
    width: 100%;
    height: 38px;
    border: none;
    outline: none;

    background: ${(props) => props.theme.colors.primaryWhite};
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: 12px;
    font-style: normal;
    line-height: normal;

    color: ${(props) => props.theme.colors.davysGrey};
    
    ::placeholder {
        color: ${(props) => props.theme.colors.clearGray};
    }
`;

const SearchIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-right: 8px;
`;

export {
  InputWrapper,
  InputField,
  SearchIcon
};
